import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminService } from 'src/app/admin/admin.service';
import { CleanedModel } from 'src/app/admin/shared/interfaces/Agreement';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalculateFileOperationService {

  constructor(private httpClient: HttpClient,
    private adminService:AdminService
  ) { }

  constructCleanedModelPayloadForIFrame(data:CleanedModel[]){
    return data?.map((item)=>({
      id:item?.id,
      name:item?.file_name || item?.model_file
    }))
  }

  generateCadUrl(cleanedModelId:string):Promise<string>{
    return new Promise<string>((res,rej)=>{
      this.adminService.getCadViewerFile(cleanedModelId).subscribe(
        (cadRes: any) => {
          let parts = cadRes.file_name.split('.');
          let ext = parts[parts.length - 1].toLowerCase();
          let type = '3D';
          if (ext === 'dxf') {
            type = '2D'
          }
          if(!cadRes?.cad_viewer_file_url){
            rej();
          }
          const viewer_url = encodeURIComponent(cadRes?.cad_viewer_file_url)
          const finalUrl = environment.cadViewerBase + '?type=' + type + '&url=' + viewer_url + '&auth=' + localStorage.getItem('token');
          res(finalUrl);
        },
        (error)=>{
          rej();
        }
      );
    })
  }
}
